import { DIV_START_SECONDS } from '../../games/data/vifMulDivData';

import { type RulesVariantConfig } from './rulesVariantConfig';

/**
 * Per-variant pacing for the 4x4 "block" VIF boards (`VIFAddSub`,
 * `VIFMulDiv`, moduleId 166-169 variant 0). Reuses `RulesVariantConfig`
 * directly - nothing here needs a shape of its own, only different values.
 */

export const BLOCK_FLAGS = [1, 2, 3, 4] as const;

export type BlockFlag = (typeof BLOCK_FLAGS)[number];

const DIV: BlockFlag = 4;

const GAMES_PER_ROUND = 4;

/** Legacy `computeStartSeconds`: shared by add/sub/mul (`VIFAddSub.ts:37-39`, `VIFMulDiv.ts:238-240`). */
const DEFAULT_START_SECONDS: readonly number[] = [0, 70, 60, 50];

/**
 * Every block board is its own game: `BlockBoardEngine.checkForEnd` wins at
 * `intCorrect >= 16` (one cleared 4x4 board) and `initGame` sets
 * `roundsInModule = 4; gamesPerRound = 4` unconditionally
 * (`games/engine/blockBoardEngine.ts:47-57,109-110`). That is exactly the
 * "one board = one game" case `useRulesBoardGame` already implements for 3x3
 * flag 5 via `endsAfterOneBoard`.
 *
 * `layersInGame` never ends a game here; it sizes the side `game` meter. The
 * layer is seeded from `game` at game start and never advances, so matching
 * it to `gamesPerRound` makes the meter follow the game within the round
 * (1-4 of 4), as the canvas `gameMeter` does (`3 + gameFrame.game`).
 */
export function blockVariantConfig(flag: BlockFlag): RulesVariantConfig {
  return {
    layersInGame: GAMES_PER_ROUND,
    roundsInModule: 4,
    gamesPerRound: GAMES_PER_ROUND,
    startSeconds: flag === DIV ? DIV_START_SECONDS : DEFAULT_START_SECONDS,
    large: false,
    endsAfterOneBoard: true,
    rejectReturnsToStart: true,
    preString: '',
  };
}
